/** @jsx h */
import { labels } from '../config';
import FilterCheckbox from './FilterCheckbox';
import { $$ } from 'utils/dom';
import { Modal } from '@3pc/modal-dialog';
import { useEffect, useState } from 'preact/hooks';
import DateRangePicker from './DateRangePicker';

const FilterFieldsetOverlay = ({
  id,
  facet,
  optionsActiveCount,
  triggerAjaxSubmit,
  pluginNamespace,
  title,
  isReset,
}) => {
  const [showStatus, setShowStatus] = useState(false);
  const [faceType, setFaceType] = useState(facet.type);
  function handleFilterCheckboxChange(e) {
    triggerAjaxSubmit();
    // show status message briefly
    setShowStatus(true);

    setTimeout(() => setShowStatus(false), 4000);
  }

  useEffect(() => {
    setFaceType(facet.type);
  }, [facet]);

  useEffect(() => {
    const modal = $$('.modal-search__content');

    if (modal.length) {
      modal.forEach(modal => {
        const openBtns = $$('[data-modal-open]', modal.parentElement);

        new Modal({
          modal,
          modalOpenBtns: openBtns,
          modalCloseBtns: $$('[data-modal-close]', modal),
          onOpen: openBtn => {
            document.querySelector('body').classList.add('modal-is-open');
          },
          onClose: closeBtn => {
            document.querySelector('body').classList.remove('modal-is-open');
          },
        }).init();
      });
    }
  }, []);

  if (faceType === 'dateRange') {
    return (
      <li className="search-form__list-item">
        <DateRangePicker
          label={facet.label}
          options={facet.options}
          filterName={facet.name}
          dateFilterObj={facet}
          triggerAjaxSubmit={triggerAjaxSubmit}
          pluginNamespace={pluginNamespace}
          isReset={isReset}
        />
      </li>
    );
  } else {
    return (
      <li className="search-form__list-item">
        <div class="modal modal-search">
          <fieldset class="modal-search__fieldset">
            <legend class="modal-search__legend">
              <button
                class="modal-search__open-button"
                type="button"
                data-modal-open=""
              >
                <span class="modal-search__legend-text">
                  {facet.label}
                  {optionsActiveCount > 0 ? (
                    <span class="search-form__selection-indicator">
                      <span class="sr-only">
                        {labels.faceting.filterActive}
                      </span>
                    </span>
                  ) : (
                    ''
                  )}
                </span>
                <span class="icon icon--filter modal-search__open-button-icon">
                  <svg class="icon__svg" role="img" aria-hidden="true">
                    <use href="#icon-filter" />
                  </svg>
                </span>
              </button>
            </legend>
            <div
              class="modal-search__content"
              id={id}
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal-search__label"
              aria-describedby="modal-search__description"
            >
              <div class="modal-search__content-inner">
                <h3 class="modal-search__label" id="modal-search__label">
                  {facet.label}
                </h3>
                <button
                  class="modal-search__close-button"
                  type="button"
                  data-modal-close
                >
                  <span class="icon icon--close">
                    <svg class="icon__svg" role="img" aria-hidden="true">
                      <use href="#icon-close" />
                    </svg>
                  </span>
                </button>
                <p id="modal-search__description" class="sr-only">
                  Modal-search description
                </p>
                <ul class="modal-search__list">
                  {facet.options.length
                    ? facet.options.map(option => (
                        <li class="search-checkbox" key={option.name}>
                          <FilterCheckbox
                            option={option}
                            options={facet.options}
                            filterName={facet.name}
                            handleChange={handleFilterCheckboxChange}
                            pluginNamespace={pluginNamespace}
                            key={option.value}
                          />
                        </li>
                      ))
                    : ''}
                </ul>
              </div>
              {showStatus ? (
                <div className="modal-search__filter-status">
                  Ihre Suchergebnisse wurden aktualisiert
                </div>
              ) : (
                ''
              )}
            </div>
          </fieldset>
        </div>
      </li>
    );
  }
};

export default FilterFieldsetOverlay;
